<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.amcNumber" style="width: 140px;" size="small" placeholder="请输入手机卡"
                        clearable></el-input>
                    <el-input v-model="formDatas.amcRealName" style="width: 20%;" size="small" clearable
                                        placeholder="请输入实名登记人"></el-input>
                    <el-select size="small" v-model="formDatas.dmDelete" clearable @change="partserch" placeholder="请选择"
                        v-if="post == 2" style="width: 130px">
                        <el-option label="已删除" :value="2" key="2"></el-option>
                        <el-option label="未删除" :value="1" key="1"></el-option>
                    </el-select>
                    <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <el-button type="info" size="small" icon="el-icon-search" @click="SerchMore"
                        style="margin-left: 10px">更多搜索</el-button>
                    <el-button type="primary" size="small" style="margin-right: 10px;"
                        @click="Out">导出</el-button>
                    
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <!-- <el-button type="success" size="small" style="margin-right: 20px" @click="BoxOpen">新增手机卡</el-button> -->

                    <!-- <el-button type="warning" size="small" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption" row-key-field-name="amcRealIdcard"
                        :cellSelectionOption="cellSelectionOption" style="width: 100%" :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage" :page-size="formDatas.pageSize"
                        :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑手机卡' : '新增手机卡'" :before-close="handleClose"
                :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                            <el-form-item label="手机卡" prop="amcNumber">
                                <el-input v-model="form.amcNumber" style="width: 50%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="运营商" prop="aocId">
                                <el-select v-model="form.aocId" placeholder="请选择分类">
                                    <el-option v-for="item in aocTypearr || []" :label="item.aocName" :value="item.aocId"
                                        :key="item.aocId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="短号" prop="amcNumberCornet">
                                <el-input v-model="form.amcNumberCornet" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="套餐" prop="amcCombination">
                                <el-input v-model="form.amcCombination" style="width: 50%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="实名登记人" prop="amcRealName">
                                <el-input v-model="form.amcRealName" style="width: 50%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="身份证" prop="amcRealIdcard">
                                <el-input v-model="form.amcRealIdcard" style="width: 50%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="任职状态" prop="amcRealJobStatus">
                                <el-select v-model="form.amcRealJobStatus" clearable placeholder="请选择" style="width: 130px">
                                    <el-option label="离职" value="离职" key="2"></el-option>
                                    <el-option label="在职" value="在职" key="1"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="服务密码" prop="amcPw">
                                <el-input v-model="form.amcPw" style="width: 50%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="套餐合约" prop="amcTreaty">
                                <el-select v-model="form.amcTreaty" clearable placeholder="请选择" style="width: 130px">
                                    <el-option label="有" value="有" key="2"></el-option>
                                    <el-option label="无" value="无" key="1"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="缴费方式" prop="amcPayMethod">
                                <el-input v-model="form.amcPayMethod" style="width: 50%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="开卡日期" prop="amcDateOpen">
                                <el-date-picker v-model="form.amcDateOpen" type="date" value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>

                            <el-form-item label="备注" prop="amcDes">
                                <el-input v-model="form.amcDes" style="width: 50%;" placeholder="请输入"></el-input>
                            </el-form-item>

                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>
            <!-- 筛选 -->
            <el-dialog title="更多搜索" :visible.sync="IsSerch" width="70%" top="8vh" :close-on-click-modal="false">
                <div style=" width: 94%; height: 90%;margin:1% auto;background-color: white;overflow-y: scroll;">
                    <div style="width: 100%; height: 100%; padding: 5%">
                        <el-form ref="formDatas" :model="formDatas" label-position="left" label-width="150px"
                            @submit.native.prevent>
                            <div style="width: 50%; display: inline-block">
                                <el-form-item label="手机卡">
                                    <el-input v-model="formDatas.amcNumber" style="width: 80%;"
                                        placeholder="请输入"></el-input>
                                </el-form-item>
                                <el-form-item label="姓名">
                                    <el-input v-model="formDatas.amcBorrowAuName" style="width: 80%;" placeholder="请输入"></el-input>
                                </el-form-item>
                                <!-- <el-form-item label="归属">
                                    <el-input v-model="formDatas.auBelong" style="width: 80%;"
                                        placeholder="请输入"></el-input>
                                </el-form-item> -->
                                <el-form-item label="所在部门">
                                    <el-input v-model="formDatas.auDepartment" style="width: 80%;"
                                        placeholder="请输入"></el-input>
                                </el-form-item>
                                <el-form-item label="领用日期">
                                    <el-date-picker v-model="formDatas.aubrBorrowDateStart" type="date" value-format="yyyy-MM-dd"
                                        placeholder="选择开始日期" style="width: 45%;">
                                    </el-date-picker> -
                                    <el-date-picker v-model="formDatas.aubrBorrowDateEnd" type="date" value-format="yyyy-MM-dd"
                                        placeholder="选择结束日期"  style="width: 45%;">
                                    </el-date-picker>
                                </el-form-item>
                            </div>
                            <div style="width: 50%; display: inline-block">
                                <!-- <el-form-item label="实名登记人">
                                    <el-input v-model="formDatas.amcRealName" style="width: 80%;"
                                        placeholder="请输入"></el-input>
                                </el-form-item> -->
                                <el-form-item label="身份证">
                                    <el-input v-model="formDatas.amcRealIdcard" style="width: 80%;"
                                        placeholder="请输入"></el-input>
                                </el-form-item>
                                <el-form-item label="套餐">
                                    <el-input v-model="formDatas.amcCombination" style="width: 80%;"
                                        placeholder="请输入"></el-input>
                                </el-form-item>
                                <el-form-item label="设备状态">
                                    <el-select v-model="formDatas.amcStatus" clearable @change="partserch" placeholder="请选择"
                                        style="width: 130px">
                                        <el-option label="闲置" :value="1" key="1"></el-option>
                                        <!-- <el-option label="报废" :value="2" key="2"></el-option>
                                        <el-option label="维修" :value="3" key="3"></el-option> -->
                                        <el-option label="领用" :value="4" key="4"></el-option>
                                        <el-option label="借用" :value="5" key="5"></el-option>
                                        <!-- <el-option label="退租" :value="6" key="6"></el-option>
                                        <el-option label="丢失" :value="7" key="7"></el-option> -->
                                    </el-select>
                                </el-form-item>
                            </div>

                            <el-form-item>
                                <el-button type="primary" @click="partserch(), IsSerch = false"
                                    style="margin-left: 100px">立即搜索</el-button>
                                <el-button @click="closeSizer()" style="margin-left: 200px">取消</el-button>
                            </el-form-item>
                        </el-form>

                    </div>
                </div>
            </el-dialog>
       
            <!-- 详情 -->
            <el-dialog title="详情" :visible.sync="IsDetail" width="70%" top="8vh">
                <div style="max-height: 700px; overflow-y: scroll">
                    <el-descriptions :column="3" border :labelStyle="{
                        color: '#409EFF',
                        textAlign: 'center',
                        width: '14%',
                        fontSize: '12px'
                    }" :contentStyle="{ textAlign: 'center', width: '18%', fontSize: '12px' }">
                        <el-descriptions-item label="手机卡">{{ DetailArr.amcNumber }}</el-descriptions-item>
                        <el-descriptions-item label="运营商">{{ DetailArr.aocName }}</el-descriptions-item>
                        <el-descriptions-item label="短号">{{ DetailArr.amcNumberCornet }}</el-descriptions-item>
                        <el-descriptions-item label="套餐">{{ DetailArr.amcCombination }}</el-descriptions-item>
                        <el-descriptions-item label="备注">{{ DetailArr.amcDes }}</el-descriptions-item>
                        <el-descriptions-item label="实名登记人">{{ DetailArr.amcRealName }}</el-descriptions-item>
                        <el-descriptions-item label="身份证">{{ DetailArr.amcRealIdcard }}</el-descriptions-item>
                        <el-descriptions-item label="任职状态">{{ DetailArr.amcRealJobStatus }}</el-descriptions-item>
                        <el-descriptions-item label="开卡日期">{{ DetailArr.amcDateOpen }}</el-descriptions-item>
                        <el-descriptions-item label="服务密码">{{ DetailArr.amcPw }}</el-descriptions-item>
                        <el-descriptions-item label="套餐合约">{{ DetailArr.amcTreaty }}</el-descriptions-item>
                        <el-descriptions-item label="缴费方式">{{ DetailArr.amcPayMethod }}</el-descriptions-item>


                        <el-descriptions-item label="创建时间">{{ DetailArr.createtime }}</el-descriptions-item>
                        <el-descriptions-item label="当前使用者">{{ DetailArr.amcBorrowAuName }}</el-descriptions-item>
                        <el-descriptions-item label="部门">{{ DetailArr.auDepartment }}</el-descriptions-item>
                        <!-- <el-descriptions-item label="归属">{{ DetailArr.auBelong }}</el-descriptions-item> -->
                        <el-descriptions-item label="设备状态">
                            <el-tag size="small">{{ DetailArr.amcStatus == 1 ? '闲置' :
                                DetailArr.amcStatus == 2 ? '报废' : DetailArr.amcStatus
                                    == 3 ? '维修' : DetailArr.amcStatus == 4 ? '领用' : DetailArr.amcStatus == 5 ? '借用' :
                                        DetailArr.amcStatus == 6 ? '退租' : '丢失' }}</el-tag>
                        </el-descriptions-item>

                    </el-descriptions>


                </div>
            </el-dialog>
           
        </div>
    </div>
</template>
  
<script>
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import {
    getAjMobileCardRealNameStatistics, addAjMobileCard, updateAjMobileCard, deleteAjMobileCard, addAjUserBorrow, getAjUserList,getAjAssetsItems,
    getAjOperatorTelecommunicationList, getAjMobileCardDetails, uploadImportAjMobileCard, exportAjMobileCard, uploadAjMobileCard, updateAjMobileCardReturn
} from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {

            amcRealJobStatusarr: [{
                id: 1,
                key: '在职',
                value: '在职'
            },
            {
                id: 2,
                key: '离职',
                value: '离职'
            }
            ],
            amcTreatyarr: [{
                id: 1,
                key: '有',
                value: '有'
            },
            {
                id: 2,
                key: '无',
                value: '无'
            }
            ],
            dateUpdata: '',
            dbtrue: false,
            type: '',
            IsImg: false,
            TypeId: 0,
            EditArr: [],
            sitId: '',
            TemstrongArr: [],
            importData: {},
            bulkData: [],
            bulkDataCopy: [],
            bulkImport: false,
           //表格的列

            DetailArr: [],
            IsDetail: false,
            userArr: [],
            formBw: {

            },
            ISborrow: false,
            aocTypearr: [],

            dialog: false,
            IsSerch: false,
            edit: false,
            form: {
                amcNumber: '',
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 20,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                // {
                //     field: "",
                //     key: "checkbox",
                //     // type=checkbox
                //     type: "checkbox",
                //     fixed: 'left',
                //     title: "",
                //     width: 50,
                //     align: "center",
                // },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "amcRealName",
                    key: "amcRealName",
                    title: "实名人",
                    width: 100,
                    align: "center",
                    fixed: 'left',
                   
                },
                {
                    field: "auDateEntryDays",
                    key: "auDateEntryDays",
                    title: "在职时间",
                    width: 100,
                    align: "center",
                   
                },
                {
                    field: "amcRealIdcard",
                    key: "amcRealIdcard",
                    title: "身份证号",
                    align: "center",
                    width: 200,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },

                // {
                //     field: "auBelong",
                //     key: "auBelong",
                //     title: "归属",
                //     align: "center",
                //     // edit: true,
                //     width: 150,
                //     ellipsis: {
                //         showTitle: true,
                //         lineClamp: 2,
                //     },
                // },
                {
                    field: "amcRealJobStatus",
                    key: "amcRealJobStatus",
                    title: "状态",
                    align: "center",
                    // edit: true,
                    width: 80,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                   

                },
                {
                    field: "auDepartment",
                    key: "auDepartment",
                    title: "部门",
                    align: "center",
                    width: 100,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "amcNumOne",
                    key: "amcNumOne",
                    title: "移动号卡数",
                    align: "center",
                    width: 90,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "amcNumTwo",
                    key: "amcNumTwo",
                    title: "电信号卡数量",
                    align: "center",
                    width: 90,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "amcNumThree",
                    key: "amcNumThree",
                    title: "联通号卡数量",
                    align: "center",
                    width: 90,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "amcNumTotal",
                    key: "amcNumTotal",
                    title: "号卡总数",
                    align: "center",
                    width: 100,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
          
                
                {
                    field: "amcCardOne",
                    key: "amcCardOne",
                    title: "移动号卡",
                    align: "center",
                    width: 260,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
              
                {
                    field: "amcCardTwo",
                    key: "amcCardTwo",
                    title: "电信号卡",
                    align: "center",
                    width: 260,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                 
                },
                
                {
                    field: "amcCardThree",
                    key: "amcCardThree",
                    title: "联通号卡",
                    align: "center",

                    width: 300,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                 
                },
                {
                    field: "amcDes",
                    key: "amcDes",
                    title: "备注",
                    align: "center",
                    // edit: true,
                    width: 150,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                amcBorrowAuName: "",
                auBelong: "",
                auDepartment: "",
                amcRealName: "",
                amcRealIdcard: "",
                amcNumber: "",
                amcCombination: "",
                amcStatus: "",
                dmDelete: 1,
                currentPage: 1,
                pageSize: 20,
            },
        };
    },
    activated() {
        // getAjUserList().then(res => {
        //     this.userArr = res.data
        // })
        getAjOperatorTelecommunicationList().then(res => {
            this.aocTypearr = res.data
        })
        this.getList();
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {

        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.getList();
    },
    mounted() {

    },
    methods: {
        // 批量删除
      BulkDelete() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        deleteAjMobileCard({ amcIds: this.selectedRowKeysCollection.toString() }).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功!",
                                });

                                this.partserch()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },
        async ob(i, item) {
            const filterarr = []
            const data = await getAjAssetsItems({itemType:4,item })
            console.log(data);
            if (this.formDatas[item + 'ListString']) {
                const arr = this.formDatas[item + 'ListString'].split(',')
                arr.forEach((datas, i) => {
                    data.data.forEach((ite, index) => {
                        if (datas == ite.name) {
                            console.log(datas);
                            const s = {
                                label: ite.name + `(${ite.num})`,
                                selected: true,
                                value: index
                            }
                            filterarr.push(s)

                        }
                        const s = {
                            label: ite.name + `(${ite.num})`,
                            selected: true,
                            value: index
                        }
                        filterarr.push(s)
                    })
                })
                let map = new Map();
                let filterList = []
                for (let itt of filterarr) {
                    map.set(itt.id, itt)
                }
                filterList = [...map.values()]
                filterarr = filterList
            } else {
                data.data.forEach((ite, index) => {
                    console.log('初始化');
                    const s = {
                        label: ite.name + `(${ite.num})`,
                        selected: false,
                        value: index
                    }
                    filterarr.push(s)
                })
            }
            this.$nextTick(() => {
                this.$set(this.columns[i].filter, 'filterList', filterarr)
                this.$refs['vetable'].colgroups[i].filter.filterList = filterarr

            })
        },
        searchByNameField(labels, id) {
            this.bulkData = this.bulkDataCopy.filter(
                (x) => labels.length === 0 || labels.includes(x[id]),
            );
        },
        searchByNameFieldCopy(labels, id) {
            if (labels == []) {
                this.formDatas[id] = '';
                this.partserch()
                return
            }
            const arr = labels
            labels.forEach((item, index) => {
                const a = item.indexOf('(');
                arr[index] = item.substring(0, a);
            })
            this.formDatas[id] = arr.toString();
            this.partserch()
            // this.bulkData = this.bulkDataCopy.filter(
            //     (x) => labels.length === 0 || labels.includes(x[id]),
            // );
        },
        addReturn(row) {
            this.$confirm("是否确定要归还吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {

                    updateAjMobileCardReturn({ amcId: row.amcId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "归还成功!",
                            });
                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        sureDate() {
            this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(this.dateKeys, this.dateUpdata);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.amcId = this.keysId
                    updateAjMobileCard(jsonObj).then(res => {
                        if (res.status == 200) {
                            this.$nextTick(() => {
                                console.log(this.tableData[this.dateIndexs], this.dateKeys);
                                this.tableData[this.dateIndexs][this.dateKeys] = this.dateUpdata
                            });
                            this.dbtrue = false;
                            this.$message({
                                type: "success",
                                message: "编辑成功!",
                            });
                        }

                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        getdbtrue(val, key, index, id, typeid, Arr) {
            console.log("双击", val, key, index);
            this.dbtrue = true;
            this.dateUpdata = val;
            this.dateKeys = key;
            this.dateIndexs = index;
            this.keysId = id;
            this.TypeId = typeid;
            this.EditArr = Arr

        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },

        Out() {
            const bulkdata = {
                    ...this.formDatas
                }
                var s = qs.stringify(bulkdata);
                this.openLoading()
                var that = this
                axios({
                    method: 'post',
                    url: config.baseURL + '/aj-mobile-card/exportAjMobileCardRealNameStatistics',
                    data: s,
                    // withCredentials: true,
                    timeout: 1200000,
                    responseType: 'arraybuffer',
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                        'userid': window.localStorage.getItem('userid')
                    }
                }).then(function (res) {
                    if (res.data) {
                        console.log(res)
                        that.loadings.close()
                        let a = document.createElement('a');
                        //ArrayBuffer 转为 Blob
                        let blob = new Blob([res.data], {
                            type: "application/vnd.ms-excel"
                        });
                        let objectUrl = URL.createObjectURL(blob);
                        a.setAttribute("href", objectUrl);
                        a.setAttribute("download",'手机卡实名信息.xlsx');
                        a.click();
                        that.$message({
                            message: "成功",
                            type: "success"
                        });

                    }
                })

        },


        searchByNameField(labels, id) {
            this.bulkData = this.bulkDataCopy.filter(
                (x) => labels.length === 0 || labels.includes(x[id]),
            );
        },
        bulkImportClick() {
            if (this.sitId == '') {
                this.$message({
                    showClose: true,
                    message: "请导入资料",
                    type: 'danger'
                });
            } else {
                this.openLoading()
                uploadImportAjMobileCard({
                    sitId: this.sitId
                }).then(res => {
                    this.loadings.close()
                    this.getList()
                    this.bulkImport = false;
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.sitId = '';
                    this.$refs['bulk'].clearFiles()

                    this.$message({
                        type: 'success',
                        message: '导入成功!'
                    });
                })
            }

        },
        async updatabulk(file, fileList) {

            console.log(file, fileList);
            let Data = new FormData();
            Data.append('file', file.raw)
            this.openLoading()
            uploadAjMobileCard(Data).then(res => {
                console.log("上传成功")
                this.loadings.close()
                this.bulkData = res.data.data.resultList;
                this.bulkDataCopy = res.data.data.resultList;
                this.importData = res.data.data.importData;
                this.sitId = res.data.data.sysImportTem.sitId;

            })
        },
        bulkImportClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                    this.bulkData = [];
                    this.bulkDataCopy = [];

                    this.$nextTick(() => {
                        this.getList()
                    })
                    this.$refs.bulk.clearFiles();
                })
                .catch(_ => { });
        },

        downloadFile(url, name) {//下载
            if (!url) {
                return
            }
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.onload = function () {
                document.body.removeChild(link);
            };
            link.setAttribute('download', name);
            document.body.appendChild(link);
            link.click();
        },

        getDetail(id) {
            getAjMobileCardDetails({ amcId: id }).then(res => {
                this.DetailArr = res.data;
                this.IsDetail = true;
                console.log(this.DetailArr);
            })
        },
        addBorrow(val, id) {
            this.$nextTick(() => {
                this.formBw.aubrThisId = val.amcId;
                this.formBw.aubrType = 4;
                this.formBw.aubrBorrowReturn = id;
                this.formBw.name = val.amcNumber;
            })

            this.ISborrow = true;
        },
        sureBorrow() {

            this.$confirm("是否确定要出借吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    addAjUserBorrow(this.formBw).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "出借成功!",
                            });
                            this.CloseBorrow()
                            this.getList()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })

        },
        CloseBorrow() {
            this.ISborrow = false;

            this.$refs['formBw'].resetFields();
        },

        closeSizer() {
            this.formDatas = {
                amcBorrowAuName: "",
                auBelong: "",
                auDepartment: "",
                amcRealName: "",
                amcRealIdcard: "",
                amcNumber: "",
                amcCombination: "",
                amcStatus: "",
                dmDelete: 1,
                currentPage: 1,
                pageSize: 20,
            };
            this.IsSerch = false;
            this.partserch()
        },
        SerchMore() {
            this.IsSerch = true;
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    deleteAjMobileCard({ amcIds: row.amcId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        addAjMobileCard(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateAjMobileCard(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.amcId = row.amcId
                    console.log(jsonObj);
                    updateAjMobileCard(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys() {
            console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item.amcId) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item.amcId);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys) {
            console.log(isSelected, selectedRowKeys);
            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item.amcId) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item.amcId), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected) {
            const rowKey = row.amcId;

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getAjMobileCardRealNameStatistics(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys();
                // this.$message({
                //     type: "success",
                //     message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getAjMobileCardRealNameStatistics(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys();
                // this.$message({
                //     type: "success",
                //     message: "搜索成功!",
                // });
            });
        },
        getList() {
            getAjMobileCardRealNameStatistics(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>
  
<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>
  